import { GenderType } from '@/shared/types/enums';

export const GenderList = [
  {
    label: 'Male',
    key: GenderType.MALE,
  },
  {
    label: 'Female',
    key: GenderType.FEMALE,
  },
  {
    label: 'Other',
    key: GenderType.OTHER,
  },
];
/**
 * @deprecated Use ../personalIdentifiersDocuments
 */
export * from '../personalIdentifiersDocuments';
